import { render, staticRenderFns } from "./BankView.vue?vue&type=template&id=c0f6bfca&lang=pug"
import script from "./BankView.vue?vue&type=script&lang=js"
export * from "./BankView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports